import { connectInitialDb } from "../actions";
import { rememberDatabase } from "./readingContext";

// Switch the working database and reload so every tree and cached process
// structure is fetched again from the new database. Which server a database
// lives on is the backend's decision (its database registry), so every
// database - AuraDB included - is switched to the same way.
export default async function switchDatabase(db, history) {
  history.push(`/home/${db}`);
  rememberDatabase(db);
  await connectInitialDb();
  history.go(0);
}

// The same switch without going home: for a page the reader means to stay on
// (Manage workspace, where choosing another workspace has to move the
// database behind it too, or the bar would name one the workspace doesn't
// give). Everything is re-read exactly as above.
export async function switchDatabaseInPlace(db, history) {
  rememberDatabase(db);
  await connectInitialDb();
  history.go(0);
}
